import { useSearchParams } from 'react-router-dom';
import { useMemo } from 'react';

interface NavigationUrls {
  backToListUrl: string;
  fromParams: string | null;
}

interface NavigationHelpers {
  buildUrlWithListState: (basePath: string) => string;
  buildDetailUrl: (id: number) => string;
  buildEditUrl: (id: number) => string;
  buildNewUrl: () => string;
}

export interface UseNavigationStateResult extends NavigationUrls, NavigationHelpers {}

export function useNavigationState(): UseNavigationStateResult {
  const [searchParams] = useSearchParams();
  const fromParams = searchParams.get('from');

  const urls = useMemo(() => {
    const backToListUrl = fromParams 
      ? `/?${decodeURIComponent(fromParams)}` 
      : '/';
    return { backToListUrl, fromParams };
  }, [fromParams]);

  const helpers = useMemo(() => ({
    buildUrlWithListState: (basePath: string): string => {
      return fromParams 
        ? `${basePath}?from=${encodeURIComponent(fromParams)}` 
        : basePath;
    },
    buildDetailUrl: (id: number): string => {
      return fromParams 
        ? `/invoices/${id}?from=${encodeURIComponent(fromParams)}` 
        : `/invoices/${id}`;
    },
    buildEditUrl: (id: number): string => {
      return fromParams 
        ? `/invoices/${id}/edit?from=${encodeURIComponent(fromParams)}` 
        : `/invoices/${id}/edit`;
    },
    buildNewUrl: (): string => {
      return fromParams 
        ? `/invoices/new?from=${encodeURIComponent(fromParams)}` 
        : '/invoices/new';
    },
  }), [fromParams]);

  return { ...urls, ...helpers };
}

export default useNavigationState;
